import type { PrayerEvent, PrayerTiming } from "@/types/prayer";

type PrayerTimingListProps = {
  activeEvent: PrayerEvent | null;
  timings: PrayerTiming[];
  variant?: "compact" | "panel";
};

type PrayerTimingRowProps = {
  isCompact: boolean;
  isActive: boolean;
  timing: PrayerTiming;
};

const getRowClassName = (isCompact: boolean, isActive: boolean) => {
  if (isCompact) {
    return isActive
      ? "bg-white/10 px-3 py-2 shadow-lg ring-1 ring-emerald-400/40 backdrop-blur"
      : "bg-white/5 px-3 py-2";
  }

  return isActive ? "bg-white/10 px-4 py-3 shadow-lg ring-2 ring-emerald-400/40 backdrop-blur" : "bg-white/5 px-4 py-3";
};

const getTextClassName = (isCompact: boolean, isActive: boolean) =>
  `font-semibold ${isCompact ? "text-base" : "text-2xl md:text-3xl"} ${isActive ? "text-white" : "text-zinc-100"}`;

const PrayerTimingRow = ({ isCompact, isActive, timing }: PrayerTimingRowProps) => (
  <li
    className={`flex items-center justify-between rounded-2xl transition-colors ${getRowClassName(isCompact, isActive)}`}
  >
    <div>
      <div className={getTextClassName(isCompact, isActive)}>{timing.label}</div>
    </div>
    <div className={getTextClassName(isCompact, isActive)}>{timing.time}</div>
  </li>
);

const PrayerTimingList = ({ activeEvent, timings, variant = "panel" }: PrayerTimingListProps) => {
  const isCompact = variant === "compact";
  return (
    <ul className={`grid ${isCompact ? "gap-2" : "gap-3"}`}>
      {timings.map((timing) => (
        <PrayerTimingRow
          isActive={timing.event === activeEvent}
          isCompact={isCompact}
          key={timing.event}
          timing={timing}
        />
      ))}
    </ul>
  );
};

export default PrayerTimingList;
